module.exports = __webpack_public_path__ + "img/logo-white.8e84fc67.svg";